// Remove the no-js class on the HTML when JavaScript is enabled
(function () {
  var elHtml = document.querySelector('.no-js');

  if (elHtml.classList) {
    elHtml.classList.remove('no-js');
  }
}());
